import { isPropertyInFlanders, isPropertyInBrussels } from "@/shared/scripts/ValidateData";

export type FloodInfoRegion = "flanders" | "wallonia" | "brussels";

/**
 * Region-specific "More information about flood zones" links (WATERINFO ticket).
 *
 * Each region's official flood-info portal is published in that region's own
 * language (Flanders: NL, Wallonia: FR, Brussels: NL) and has no verified
 * per-language equivalent, so we serve the single available link in every locale.
 */
const floodInfoLinks: Record<FloodInfoRegion, string> = {
    flanders: "https://waterinfo.vlaanderen.be/overstromingsrichtlijn",
    wallonia: "https://environnement.wallonie.be/home/gestion-environnementale/risques-climatiques/inondations/urbanisme/cartes-inondations.html",
    brussels: "https://leefmilieu.brussels/burgers/documentatie-en-tools/kaarten/overstromingskaarten-voor-het-brussels-gewest",
};

// Maps a property address to its Belgian flood-info region. Anything that is not
// Flanders or Brussels falls back to Wallonia (matches the previous non-Flanders link).
export function getFloodInfoRegion(country: string, postalCode: string): FloodInfoRegion {
    if (isPropertyInFlanders(country, postalCode)) {
        return "flanders";
    }
    if (isPropertyInBrussels(country, postalCode)) {
        return "brussels";
    }
    return "wallonia";
}

export function floodInfoLink(region: FloodInfoRegion): string {
    return floodInfoLinks[region];
}
